import { Constants } from 'constants';

import React from 'react';
import PropTypes from 'prop-types';
import { PercentageChart } from '@genie-ui/react';

import './AxisChart.scss';

function AxisChart({
  value,
  maxLimit,
}) {
  const valueInNumber = Number(value.replace(/%/g, ''));

  return (
    <PercentageChart
      value={valueInNumber}
      referenceValue={maxLimit}
      maxLimit={100}
      referenceLabel={Constants.GUAGE_CHART.TOP_PERFORMERS}
      className="chart"
    />
  );
}

AxisChart.propTypes = {
  value: PropTypes.string,
  maxLimit: PropTypes.number,
};

AxisChart.defaultProps = {
  value: '0%',
  maxLimit: 0,
};

export default AxisChart;
